import { Injectable, signal, inject } from '@angular/core';
import moment from 'moment';
import { BehaviorSubject, firstValueFrom } from 'rxjs';
import { RequestBuilderService } from './request-builder.service';

@Injectable({
  providedIn: 'root',
})
export class FiltersService {
  private readonly requestBuilder = inject(RequestBuilderService);

  private readonly filterTriggerSource = new BehaviorSubject<any>([]);
  filterTriggered$ = this.filterTriggerSource.asObservable();
  totalResults = signal<number>(0);

  triggerFilterAction(data: any): void {
    if (data) {
      const filters = data.filterResults.map((item: any) => ({
        field: item.moreInformation.controlName,
        operator: 'Equals',
        value: item.value.toString(), // Convert value to a string
        ignoreCase: '',
      }));
      filters.searchAllText = data.search;
      this.filterTriggerSource.next(filters);
    } else {
      this.filterTriggerSource.next([]);
    }
  }

  async setDateOfService() {
    let serverTimezone = localStorage.getItem('serverTimezone') ?? '';

    if (!serverTimezone) {
      const res = await firstValueFrom(this.requestBuilder.get(`configurations/server-timezone`));
      localStorage.setItem('serverTimezone', res.message ?? '');
      serverTimezone = res.message!;
    }

    const today = moment.utc().zone(`${serverTimezone}`).clone().startOf('day');
    const targetTime = today.clone().add(18, 'hours').add(30, 'minutes');

    const serviceDate = moment.utc().zone(`${serverTimezone}`).isAfter(targetTime) ? today.add(1, 'day').format('MM/DD/YYYY') : today.format('MM/DD/YYYY');
    localStorage.setItem('serviceDate', serviceDate);
  }
}
